export default "__VITE_ASSET__BYxneNJY__"